var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownSm = function SvgChevronDownSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-down-sm_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.13 24.21 14 26.34l8.5 8.5 8.5 8.5 8.5-8.5 8.5-8.5-2.13-2.13-2.13-2.13-6.37 6.37L31 34.82l-6.37-6.37-6.37-6.37z",
    clipRule: "evenodd"
  })));
};
export { SvgChevronDownSm as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjEzIDI0LjIxTDE0LjAwMDEgMjYuMzQwMUwyMi41IDM0Ljg0TDMxIDQzLjMzOThMMzkuNSAzNC44NEw0Ny45OTk5IDI2LjM0MDFMNDUuODcgMjQuMjFMNDMuNzQwMiAyMi4wNzk4TDM3LjM3MDEgMjguNDQ5OEwzMSAzNC44MTk4TDI0LjYyOTkgMjguNDQ5OEwxOC4yNTk4IDIyLjA3OThMMTYuMTMgMjQuMjFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";